// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SketchComponent } from 'roofsnap-sketchtool';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { hideSketch } from '../../actions/sketchHostActions';
import { getSketchOrder } from '../../actions/sketchOrderActions';
import { SketchOrderStatus } from '../../lib/sketchOrderStatuses';
import { ROOFSNAP_API_BASE_URL } from '../../lib/apiClients/roofSnapApiClient/roofSnapApiClient';

type ProvidedProps = {
    dispatch: Function,
    history: {
        push: Function,
    },
    accessToken: string,
    show: boolean,
    apiKey: string,
    baseApiUrl: string,
    baseFacetFindingApiUrl: string,
    baseMeasurementApiUrl: string,
    orderId: number,
    projectId: string,
    sketchReportType: string,
    basePitchApiUrl: string,
    displayPitchTool: boolean,
    saveImages: boolean,
    sketchOrders: Object,
    isAdmin: boolean,
    isSketchTech: boolean,
};

type ProjectDrawing = {
    Measurements: {
        WastePercentage: number,
    }
}

type WasteCalculation = {
    suggestedWastePercent: number,
}

class SketchComponentHost extends Component<ProvidedProps> {
    static defaultProps = {
        orderId: null,
    };
    componentDidUpdate(prevProps: ProvidedProps) {
        if (this.props.show && !this.authorizedToOpenDrawing()) {
            this.navigateToOrder();
        }

        //we're doing this in case the sketch scene was loaded directly through the URL
        if (this.props.show && this.props.orderId !== prevProps.orderId) {
            this.getSketchOrder();
        }
    }

    sketchOrder = () => this.props.sketchOrders[this.props.orderId] || {};

    authorizedToOpenDrawing = () => this.props.isAdmin || (this.props.isSketchTech && this.sketchOrder().sketchOrderStatus === SketchOrderStatus.InProgress);

    getSketchOrder = () => {
        this.props.dispatch(getSketchOrder(this.props.orderId));
    };
    navigateToOrder = async () => {
        await this.props.dispatch(getSketchOrder(this.props.orderId));
        this.props.history.push(`/orders/${this.props.orderId}`);
        this.props.dispatch(hideSketch());
    };
    handleWasteCalculationUpdated = (projectDrawing: ProjectDrawing, wasteCalculation: WasteCalculation) => {
        const { sketchReportType } = this.sketchOrder();

        const dynamicWasteReports = ["FullSnap", "MetalRoof"];

        if (dynamicWasteReports.includes(sketchReportType)) {
            projectDrawing.Measurements.WastePercentage = wasteCalculation.suggestedWastePercent;
        }
    };
    render() {
        const {
            show,
            accessToken,
            projectId,
            displayPitchTool,
            saveImages,
        } = this.props;
        return (
            <SketchComponent
                start={show && this.authorizedToOpenDrawing()}
                jwt={accessToken}
                baseApiUrl={`${ROOFSNAP_API_BASE_URL}/v1`}
                baseFacetFindingApiUrl={process.env.REACT_APP_FACEFINDING_HOST}
                baseMeasurementApiUrl={process.env.REACT_APP_MEASUREMENT_HOST}
                apiKey={process.env.REACT_APP_API_KEY}
                projectId={projectId}
                cocosScript="https://roofsnapstaticassets.blob.core.windows.net/assets/cocos2d-js-v3.12-min.js"
                onClose={this.navigateToOrder}
                onWasteCalculationUpdated={this.handleWasteCalculationUpdated}
                rsClient="ShadyShark"
                basePitchApiUrl={process.env.REACT_APP_PITCH_HOST}
                displayPitchTool={displayPitchTool}
                saveImages={false}
                disablePitchTool={true}
                hideGutterPins = {false}
            />
        );
    }
}

const mapStateToProps = (state) => {
    const { auth, sketchHost} = state;
    const { accessToken } = auth;
    const { currentUserRoles } = state;
    const { sketchOrders: sketchOrdersState } = state;
    const { sketchOrders } = sketchOrdersState;

    const { isSketchTech } = currentUserRoles;
    const isAdmin = currentUserRoles.isAdmin || currentUserRoles.isSketchOsAdmin;
    const isRoofSnapAdmin = currentUserRoles.isAdmin;
    return {
        ...sketchHost,
        accessToken,
        isAdmin,
        isSketchTech,
        displayPitchTool: isRoofSnapAdmin,
        sketchOrders,
    }
};

export { SketchComponentHost };

export default connect(mapStateToProps)(withMobileDialog()(SketchComponentHost));
